import deburr from 'lodash.deburr';

export const comoMoneda = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
}).format;

export const slugify = text => deburr(text.toLowerCase());

export const MES_POR_NUMERO = {
    1: 'Enero',
    2: 'Febrero',
    3: 'Marzo',
    4: 'Abril',
    5: 'Mayo',
    6: 'Junio',
    7: 'Julio',
    8: 'Agosto',
    9: 'Septiembre',
    10: 'Octubre',
    11: 'Noviembre',
    12: 'Diciembre',
};

export const buildSearch = text =>
    slugify(text)
        .replace(/[-\/\\^$*+?.()|[\]{} ]/g, '')
        .split('')
        .join('.*');

const keys = new Set(['Enter', 'Escape', 'ArrowUp', 'ArrowDown']);

export function keydowns(node, useKeys = keys) {
    function handleKeydown({ key }) {
        if (!useKeys.has(key)) return;
        node.dispatchEvent(
            new CustomEvent(`keydown.${key}`, { detail: { ...node } })
        );
    }

    node.addEventListener('keydown', handleKeydown);

    return {
        destroy() {
            node.removeEventListener('keydown', handleKeydown);
        },
    };
}

export function clearOnEscape(node) {
    const { destroy } = keydowns(node, new Set(['Escape']));

    async function clearOnEscape() {
        node.value = '';
        node.dispatchEvent(new Event('input'));
    }

    node.addEventListener('keydown.Escape', clearOnEscape);

    return {
        destroy() {
            destroy();
            node.removeEventListener('keydown.Escape', clearOnEscape);
        },
    };
}

export function sumProp(arr, prop) {
    return arr.reduce((acc, { [prop]: val }) => acc + val, 0);
}
